module.exports = __webpack_public_path__ + "static/media/blueLogo.8594ac31.png";